import styled, { css } from "styled-components";
import { focusWell } from "../../../../../components/focusWell";

export const OtherDetailsFocusWell = styled.div(({ theme }) => css`
  ${focusWell({ variant: "white", thinBorder: true })}
  margin: 0 20px 38px;
  align-self: stretch;

  @media only screen and (min-width: ${theme.breakpoints.M}) {
    margin: 0 0 30px;
  }
`);